import React, { useState } from 'react';
import { Modal, Button, Input, Select, Result } from 'antd';
import { ModalBody, ModalContainer, InputLabel, Container, InputContainer } from './styles';
import { postServicedata } from '../../utils/services/storageAPI';
import { withTranslation } from 'react-i18next';
import {
  CLOUD_STORAGE_CONFIGURATION_MODAL,
  CLOUD_SERVICES_CONFIGURATION_MODAL,
  CLOUD_RESOURCES_CONFIGURATION_MODAL,
} from '../../containers/UserSettingsPage/TranslationValues';

const { Option } = Select;
const NAMESPACE = [
  'CLOUD_STORAGE_CONFIGURATION_MODAL',
  'CLOUD_SERVICES_CONFIGURATION_MODAL',
  'CLOUD_RESOURCES_CONFIGURATION_MODAL',
];
const SERVICE_CONFIG_MODAL = 'CLOUD_SERVICES_CONFIGURATION_MODAL'
 const RESOURCES_CONFIG_MODAL = 'CLOUD_RESOURCES_CONFIGURATION_MODAL'
const StorageModal = props => {
  const {
    visible,
    onCancel,
    targetForm,
    selectedService,
    editType,
    resourceData,
    configuredServices,
    t
  } = props;
  const [formData, setformData] = useState(targetForm);
  const [resource, setResource] = useState(resourceData);
  const [isLoading, setIsLoading] = useState(false);
  const [serviceList] = useState(configuredServices);
  const [isCloseView, setCloseView] = useState(false);

  const handlefieldschange = e => {
    let copyFormData = JSON.parse(JSON.stringify(formData));
    copyFormData[e.target.name] = e.target.value;
    setformData(copyFormData);
  };

  const handleObjectConstruction = (serviceName, data) => {
    const notallowed = ['defaultBucket'];
    const credentialsObj = Object.keys(data)
      .filter(key => !notallowed.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: data[key],
        };
      }, {});
    const dataForm = {
      name: serviceName,
      defaultBucket: '',
      credentials: {},
    };
    dataForm.defaultBucket = data.defaultBucket;
    dataForm.credentials = credentialsObj;
    return dataForm;
  };

  const saveServiceDetails = async () => {
    let payload = {};
    setIsLoading(true);
    if (editType === 'services') {
      payload[editType] = [handleObjectConstruction(selectedService, formData)];
    } else {
      payload[editType] = resource;
    }
    let response = await postServicedata(payload);
    if (response && response.errors && response.errors.length === 0) {
      setIsLoading(false);
      setCloseView(true);
    }
  };

  const resourceFieldInputHandler = (value, type) => {
    let resourceData = JSON.parse(JSON.stringify(resource));
    type === 'bucket'
      ? (resourceData[selectedService].bucket = value)
      : (resourceData[selectedService].service = value);
    setResource(resourceData);
  };

  const selectedForm = editType === 'services' ? formData : resource[selectedService];

  const isValidForm =
    selectedForm &&
    Object.values(selectedForm).every(data => {
      return data !== '';
    });

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={
          editType === 'services'
            ? `${selectedService.charAt(0).toUpperCase() +
            selectedService.slice(1).toLowerCase() + ' ' + t(`${SERVICE_CONFIG_MODAL}:${CLOUD_SERVICES_CONFIGURATION_MODAL.CLOUD_SERVICES_CONFIGURATION_MODAL_TITLE.key}`, CLOUD_SERVICES_CONFIGURATION_MODAL.CLOUD_SERVICES_CONFIGURATION_MODAL_TITLE.value)} `
            : t(`${RESOURCES_CONFIG_MODAL}:${CLOUD_RESOURCES_CONFIGURATION_MODAL.CLOUD_RESOURCES_CONFIGURATION_MODAL_TITLE.key}`, CLOUD_RESOURCES_CONFIGURATION_MODAL.CLOUD_RESOURCES_CONFIGURATION_MODAL_TITLE.value)
        }
        width="625px"
        maskClosable={false}
        centered
        visible={visible}
        onCancel={() => onCancel()}
        footer={
          !isCloseView
            ? [
              <Button key="back" onClick={() => onCancel()}>
                {t(CLOUD_STORAGE_CONFIGURATION_MODAL.CANCEL_CLOUD_STORAGE_CONFIGURATION_BUTTON.key, CLOUD_STORAGE_CONFIGURATION_MODAL.CANCEL_CLOUD_STORAGE_CONFIGURATION_BUTTON.value)}
              </Button>,
              <Button
                key="save"
                type="primary"
                disabled={!isValidForm}
                loading={isLoading}
                onClick={saveServiceDetails}
              >
                {t(CLOUD_STORAGE_CONFIGURATION_MODAL.SAVE_CLOUD_STORAGE_CONFIGURATION_BUTTON.key, CLOUD_STORAGE_CONFIGURATION_MODAL.SAVE_CLOUD_STORAGE_CONFIGURATION_BUTTON.value)}
              </Button>,
            ]
            : null
        }
      >
        <ModalBody>
          <ModalContainer width="395px">
            {isCloseView ? (
              <Result
                status="success"
                title={t(CLOUD_STORAGE_CONFIGURATION_MODAL.UPDATE_CLOUD_STORAGE_CONFIGURATION_SUCCESS_MESSAGE.key, CLOUD_STORAGE_CONFIGURATION_MODAL.UPDATE_CLOUD_STORAGE_CONFIGURATION_SUCCESS_MESSAGE.value)}
                extra={
                  <Button
                    key="back"
                    type="primary"
                    onClick={() => {
                      setCloseView(false);
                      editType === 'services' ? onCancel(formData) : onCancel(resource);
                    }}
                  >
                {t(CLOUD_STORAGE_CONFIGURATION_MODAL.CLOUD_STORAGE_CONFIGURATION_MODAL_BACK_BUTTON.key, CLOUD_STORAGE_CONFIGURATION_MODAL.CLOUD_STORAGE_CONFIGURATION_MODAL_BACK_BUTTON.value)}
                  </Button>
                }
              />
            ) : (
              <>
                {editType === 'services'
                  ? Object.keys(formData).length !== 0 &&
                  Object.entries(formData).map(([fieldName, filedvalue], index) => {
                    return (
                      <InputContainer className="full-width" key={index}>
                        <InputLabel>{fieldName}</InputLabel>
                        <Input
                          // name="fileName"
                          size="large"
                          name={fieldName}
                          value={filedvalue}
                          placeholder={t(`${SERVICE_CONFIG_MODAL}:${CLOUD_SERVICES_CONFIGURATION_MODAL.CLOUD_SERVICES_CONFIGURATION_PLACEHOLDER.key}`, CLOUD_SERVICES_CONFIGURATION_MODAL.CLOUD_SERVICES_CONFIGURATION_PLACEHOLDER.value) + ' ' + fieldName}
                          onChange={e => handlefieldschange(e)}
                          autoComplete={"off"}
                        />
                      </InputContainer>
                    );
                  })
                  : resource[selectedService] && (
                    <>
                      <InputContainer className="full-width">
                      <InputLabel>{t(`${RESOURCES_CONFIG_MODAL}:${CLOUD_RESOURCES_CONFIGURATION_MODAL.CLOUD_RESOURCE_CONFIGURATION_LABEL.key}`, CLOUD_RESOURCES_CONFIGURATION_MODAL.CLOUD_RESOURCE_CONFIGURATION_LABEL.value)}</InputLabel>
                        <Select
                          showSearch
                          placeholder={t(`${RESOURCES_CONFIG_MODAL}:${CLOUD_RESOURCES_CONFIGURATION_MODAL.CLOUD_RESOURCE_CONFIGURATION_PLACEHOLDER.key}`, CLOUD_RESOURCES_CONFIGURATION_MODAL.CLOUD_RESOURCE_CONFIGURATION_PLACEHOLDER.value)}
                          optionFilterProp="children"
                          value={resource[selectedService].service}
                          onChange={value => resourceFieldInputHandler(value, 'service')}
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {serviceList.map((data, index) => {
                            return (
                              <Option key={index} value={data}>
                                {data}
                              </Option>
                            );
                          })}
                        </Select>
                      </InputContainer>
                      <InputContainer className="full-width">
                      <InputLabel>{t(`${RESOURCES_CONFIG_MODAL}:${CLOUD_RESOURCES_CONFIGURATION_MODAL.RESOURCES_CONFIGURATION_BUCKET_NAME_LABEL.key}`, CLOUD_RESOURCES_CONFIGURATION_MODAL.RESOURCES_CONFIGURATION_BUCKET_NAME_LABEL.value)}</InputLabel>
                        <Input
                          name="bucketName"
                          size="large"
                          value={resource[selectedService].bucket}
                          placeholder={t(`${RESOURCES_CONFIG_MODAL}:${CLOUD_RESOURCES_CONFIGURATION_MODAL.RESOURCES_CONFIGURATION_BUCKET_NAME_PLACEHOLDER.key}`, CLOUD_RESOURCES_CONFIGURATION_MODAL.RESOURCES_CONFIGURATION_BUCKET_NAME_PLACEHOLDER.value)}
                          onChange={e => resourceFieldInputHandler(e.target.value, 'bucket')}
                          autoComplete={"off"}
                        />
                      </InputContainer>
                    </>
                  )}
              </>
            )}
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACE)(StorageModal);
